import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsAutocompleteComponent } from "./ds-autocomplete.component";
import { DsSelectorComponentsModule } from "../ds-selector-components/ds-selector-components.module";

@NgModule({
  declarations: [DsAutocompleteComponent],
  imports: [CommonModule, DsSelectorComponentsModule],
  exports: [DsAutocompleteComponent, DsSelectorComponentsModule],
})
export class DsAutocompleteModule {}
